<template>
  <div>
    <v-container>
      <v-row>
        <v-col>
          <h2>DAC6 Registration</h2>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-expansion-panels v-if="faqs.length">
            <v-expansion-panel v-for="faq in faqs" :key="faq.id">
              <v-expansion-panel-header class="faq-header">
                <template v-slot:actions>
                  <v-icon class="faq-icon">
                    $expand
                  </v-icon>
                </template>
                <h4>{{ faq.question }}</h4>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="faq-content pt-4">
                <div v-html="faq.answer"></div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <p v-if="!faqs.length">No frequently asked questions available</p>
        </v-col>
      </v-row>
    </v-container>
    <v-container class="mt-10">
      <v-row>
        <v-col>
          <h2>Guidance</h2>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <ul class="guidance-download-list" v-if="general_files.length">
            <li v-for="general_file in general_files" :key="general_file.name">
              <a class="primary-download" :href="general_file.url">
                <v-icon class="primary-icon mr-5" dense> mdi-file </v-icon>{{ general_file.name }}</a
              >
            </li>
          </ul>
          <p v-if="!general_files.length">No guidance documents available</p>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import helpers from '@/plugins/helpers'
import { mapGetters } from 'vuex'
export default {
  props: {},
  data: () => ({
    faqs: [],
    general_files: []
  }),
  mounted() {
    this.getFaqs()
    this.getGeneralFiles()
  },
  computed: {
    ...mapGetters({
      countrycode: 'general/countrycode'
    })
  },
  methods: {
    async getFaqs() {
      let query = `{
          allFrequentlyaskedquestion(where: { countries: { code: { eq: "${this.countrycode}"}}}) {
              results {
                  id
                  question
                  answer
                  countries {
                      id
                      code
                  }
              }
          }
      }`
      let result = await helpers.fetchGraph(query)
      if (result) {
        if (result.data.allFrequentlyaskedquestion.results) {
          this.faqs = result.data.allFrequentlyaskedquestion.results
        }
      }
    },
    async getGeneralFiles() {
      let query = `{
          oneCountry(where: { code: { eq: "${this.countrycode}"}}) {
              id
              code
              generalFiles
          }
      }`
      let result = await helpers.fetchGraph(query)
      if (result) {
        if (result.data.oneCountry) {
          this.general_files = result.data.oneCountry.generalFiles
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/style/_variables.scss';
.faq-header {
  background: #f5f5f5;
}
.faq-icon {
  color: $bdo-red !important;
}

.guidance-download-list {
  list-style-type: none;
}
.primary-download {
  color: $bdo-red !important;
  display: block;
  width: 250px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-left: -24px;
  margin-bottom: 12px;
}
.primary-icon {
  color: $bdo-red !important;
}
</style>
